import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { FormPicker } from './form-picker';
import { PartnerForm } from './partner-form';
import { QuestionForm } from './question-form';
import { ThankYouMessage } from './thank-you-message';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: transparent;
  margin-left: 1em;
`;

export const Form: FC = () => {
  const [pick, setPick] = useState<'question' | 'partner'>('question');
  const isQuestion = pick === 'question';

  const [submitted, setSubmitted] = useState(false);

  return !submitted ? (
    <Wrapper>
      <FormPicker setPick={setPick} isQuestion={isQuestion} />
      {isQuestion ? (
        <QuestionForm setSubmitted={setSubmitted} />
      ) : (
        <PartnerForm setSubmitted={setSubmitted} />
      )}
    </Wrapper>
  ) : (
    <ThankYouMessage />
  );
};
